import { ReactNode } from "react";

import { InteractionMode } from "components/server-types";
import { ClassCollaborationIcon, PersonGroupIcon, PersonSingleIcon } from "mds/icons";

export const INTERACTION_MODE_ICONS: Record<InteractionMode, ReactNode> = {
  [InteractionMode.INDIVIDUAL]: <PersonSingleIcon size="xs" />,
  [InteractionMode.SHARED_CLASS]: <ClassCollaborationIcon size="xs" />,
  [InteractionMode.ASSIGN_STUDENTS]: <PersonGroupIcon size="xs" />,
  [InteractionMode.SELF_ASSIGN]: <PersonGroupIcon size="xs" />,
  [InteractionMode.STATIC]: null,
};

export const INTERACTION_MODE_CHIP_KINDS = {
  [InteractionMode.INDIVIDUAL]: "blue",
  [InteractionMode.SHARED_CLASS]: "moss",
  [InteractionMode.ASSIGN_STUDENTS]: "hibiscus",
  [InteractionMode.SELF_ASSIGN]: "hibiscus",
};

export const PAGE_METADATA_CONTAINER_QUERY_CLASS_NAME_HIDE = "@[450px]/page-metadata:hidden";
export const PAGE_METADATA_CONTAINER_QUERY_CLASS_NAME_SHOW = "@[450px]/page-metadata:inline";
